<template>
<div class="chapter">
<div class="inner_page">
<div class="Title_Page">
<h2 class="chaptitle3"><a id="page_18"></a><a href="#/006_Contents#ch5" id="rch5"><b>Rules of TV</b></a></h2>
<p class="sub1"><b>At some point in your life, you’ve no doubt been watching a television show and muttered, “That would never happen in real life.” And yet these things happen on the tube…a lot.</b></p>
<p class="imagel"><img alt="images" src="images/img_p22-1.jpg"/></p>
<p class="imagel"><img alt="images" src="images/img_p22-2.jpg"/></p>
<p class="imagel"><a id="page_19"><img alt="images" src="images/img_p23-1.jpg"/></a></p><a id="page_19">
<p class="imagel"><img alt="images" src="images/img_p23-2.jpg"/></p>
<p class="imagel"><img alt="images" src="images/img_p23-3.jpg"/></p>
<p class="imagel"><img alt="images" src="images/img_p24-1.jpg"/></p>
<p class="imagel"><img alt="images" src="images/img_p24-2.jpg"/></p>
<p class="centers"><b>COMMON Wii GAMING SYSTEM INJURIES: BLACK EYES, HAND INJURIES, AND TENNIS ELBOW.</b></p>
</a></div><a id="page_19">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012_Chapter5.vue?b4777d6a